<template>
    <div class="all clearfix">
        <div class="grid-d mb20">
            <div class="grid-header clearfix">
                <h1>{{titles}}</h1>
            </div>
        </div>
        <div class="grid newsDetail bgff">
            
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">话题走势</h2>
                </div>
                <div class="grid-body mt15">
                    <div class="echart-warp h305">
                        <lineChart id="hotEvent" :dataArray="hotEventData" v-if="hotEventData != ''" :colorArr="colorArr" :isShowArea="false" gridBot ="60"></lineChart>
                        <div class="no-data" v-if="nodata.hotEventData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>
            <div class="grid-d clearfix">
                
                <div class="wid100 fl pl10">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">热门主题词</h2>
                        <div class="collection fr clearfix">
                            <span class="tion drop-down">
                                <button class="btn btn-lightblue">{{curHotTheme}}<i class="icons"></i></button>
                                <ul class="option">
                                    <li @click="hotThemeTab(index);" v-for="(item,index) of mtType" :key="index">{{item}}</li>
                                </ul>
                            </span>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="echart-warp h270">
                            <div class="no-data" v-if="nodata.defaultWords"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                            <cloudChart id="wordCloud" :dataArray="defaultWords" v-if="hotThemeType == 0 && defaultWords!= ''"></cloudChart>
                            <pieChart v-if="hotThemeType == 1 && hotThemePie != ''" id="pieEchart3" :dataArray="hotThemePie" :showLegend="false"></pieChart>
                            <radarChart v-if="hotThemeType == 2 && hotThemeRadar != ''" id="radarEchart" :dataArray="hotThemeRadar"></radarChart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 预览 -->
        <Dialog ref="viewModal" :callback="enterView" width="720" title="预览" :modalFoot='false'>
            <div slot="mdBox">
                <div class="artiWrap">
                    <vue-scroll :ops="ops" :style="'height:'+ scrollH">
                        <table width="100%" border="0" cellpadding="0" cellspacing="0" class="table">
                            <colgroup>
                                <col width="100%">
                            </colgroup>
                            <tbody>
                                <tr v-for="(item,index) in viewList" :key="index">
                                    <td>
                                        <a class="ovhidden" :href="item.news_url" target="_blank">{{item.news_title}}</a>
                                        <p class="mt10 cr77">
                                            <span>{{item.media_name}}</span> 
                                            <span class="ml20">{{item.news_posttime}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <ul class="article-list" :style="'height:'+ scrollH">
                            <li v-for="(item,index) in viewList" :key="index">
                                <p class=" mt5"><a class="ovhidden" :href="item.news_url" target="_blank">{{item.news_title}}</a></p>
                                <p class="ziduan mt10 cr77">
                                    <span>{{item.media_name}}</span> 
                                    <span>{{item.news_posttime}}</span>
                                </p>
                            </li>
                        </ul> -->
                        <div class="no-data" v-if="nodata.viewList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </vue-scroll>
                </div>
            </div>
        </Dialog>
        <!-- 知识图谱 -->
        <Dialog ref="knowModal" :callback="enterView" width="1000" title="知识图谱" :modalFoot='false'>
            <div slot="mdBox">
                <div class="artiWrap bg07 h800 hidden">
                    <d3chart id="d3Svg" width="952" height="460" ref="d3" :ds="dsCharts" :updateDs="updateDsCharts" @entityFatherMethod="getEntityChild"></d3chart>
                    <div class="no-data mt0 pt40" v-if="nodata.knowEntity"><img src="static/images/no_data.png" class="img"/><span class="text crff">啥也没有找到，换个词试试吧~</span></div>
                </div>
            </div>
        </Dialog>
    </div>
</template>
<script>
import Myleft from '../../components/left'
import lineChart from '../../components/echart/lineChart.vue';
import pieChart from '../../components/echart/pieChart.vue';
import radarChart from '../../components/echart/radarChart.vue';
import mapChart from '../../components/echart/mapChart.vue';
import cloudChart from '../../components/echart/wordCloud.vue';
import Dialog from '../../components/dialog.vue'
//import '../../../static/js/d3.v4.min.js'
import d3chart from '../../components/d3Chart.vue'
//import '../../../static/js/knowledge.js'
export default {
    components: {Myleft,lineChart,pieChart,radarChart,cloudChart,mapChart,Dialog,d3chart},
    data() {
        return {
            sid : this.$route.query.id,
            newsType : this.$route.query.newsType,
            type : this.$route.query.type,
            apiSecret : this.$route.query.api_secret,
            attributeType:{
                '正面':'tag-blue',
                '中性':'tag-orange',
                '负面':'tag-red',
            },//属性对应的class样式
            hotTopicsList:[],
            defaultImg:'this.src="static/images/default.png"',
            nodata:{
                hotTopicsList:false,
                viewList:false,
            },
            infoList:{},
            titles:this.$route.query.title,
            title:'',
            beginDate:'',
            description:'',
            hotOver:'',
            timeLineList:[],//时间脉络
            hotEventData:[],
            mediaData:[],
            mediaColorArr:["#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            colorArr:["#56566a","#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            curIndex:'wx',
            activeAccTab:[],
            activeAccList:[],
            wbAnalysisHtml:{},
            wbAnalysisData:[],//微博分析
            curWbType:'个人认证',
            wbTypeList:[],
            bloggerAllList:[],
            bloggerList:[],//影响力博主
            emotionData1:[],//情感属性折线
            emotionData2:[],//情感属性饼图
            tuType:'pie',//控制图表类型
            emotionColorArr:['#0095eb','#ff8121','#e63349'],
            mtType:['词云图','饼图','雷达图'],//媒体类别
            defaultWords:[],//热门主题词词云图
            wordColors: ['#3c77ce', '#bf3a54', '#2fa130', '#ce393a', '#36accd', '#c64c65'],
            curHotTheme:'词云图',
            hotThemePie:[],//热门主题词饼图
            hotThemeRadar:[],
            hotThemeType:0,
            publishAreaData:[],//发布地区
            areaChoseList:[],
            provinceFullList:[],
            curPublishArea:'全国',
            curPublishAllArea:'全国',
            mentionAreaData:[],//提及地区
            entityList:[],//人物实体
            institEntityList:[],//机构实体
            // isShowMap:true,
            // isShowMention:false,
            curMentionArea:'top',
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            gapX:0,
            startx:0,
            endx:0,
            nodata:{
                hotTopicsList:false,
                emotionData2:false,
                defaultWords:false,
                hotEventData:false,
                mediaData:false,
                activeAccList:false,
                bloggerList:false,
                entityList:false,
                institEntityList:false,
                knowEntity:false,
            },
            load:{
                activeAccList:false,
            },
            icons:{
                '微信':'wx-icon',
                '网页':'web-icon',
                '微博':'wb-icon',
                '头条':'toutiao-icon',
            },
            mediaList:{'全部':4,'网页':1,'微信':2,'微博':3,'头条':5},//媒体列表
            commendList:[],//相关文章
            firNewsList:{
                name:'',
            },//首发文章
            viewList:[],
            scrollH:'auto',
            dsCharts:[],
            updateDsCharts:[],
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> { 
            that.dataAjax();
            that.hotThemeAjax();
        }) 
    },
    methods: {
        showNewType(type,num){
            let that = this;
            for (let key in that.mediaList) {
                if(that.mediaList[key] == type){
                    if(num ==1){
                        return that.icons[key];
                    }else{
                        return key;
                    }
                }
            }
        },
        dataAjax(){
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            let datas = {sid:that.sid,api_secret: this.apiSecret};
            
            //话题走势
            that.$api.get('news/detail-oem/hot-line-chart',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.hotEventData = r.data;
                    if(r.data.length<=0){
                        that.nodata.hotEventData = true;
                        return;
                    }else{
                        that.nodata.hotEventData = false;
                    }
                    that.$parent.loadModal(false,'数据加载中...');
                });
            });
            
            
        },
        // 热门主题词切换
        hotThemeTab (type) {
            this.hotThemeType = type;
            this.curHotTheme = this.mtType[type];
        },
        // 热门主题词
        hotThemeAjax () {
            let that = this;
            // that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('news/detail-oem/hot-key-words',{sid:that.sid,api_secret: this.apiSecret},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.length<=0){
                        that.nodata.defaultWords = true;
                        return;
                    }else{
                        that.nodata.defaultWords = false;
                    }
                    that.defaultWords = r.data;
                    that.hotThemePie = r.data.slice(0,20);
                    that.hotThemeRadar = r.data.slice(0,20);
                    // that.$parent.loadModal(false,'数据加载中...');
                });
            });
        },
        
        enterView(){
            let that = this;
            that.$refs.viewModal.closeMask();
        },

        // getEntityChild(item,id){
        //     let that = this;
        //     let datas = {
        //         node_id:id,
        //         api_secret:that.apiSecret
        //     };
        //     that.$api.get('news/knowledge/node-id',datas, r => {
        //         that.$parent.returnCode(r,function(){
        //             let data = r.data;
        //             let nodeJson = {
        //                 nodes:[],
        //                 links:[],
        //             }
        //             if(data.length>0){
        //                 data.forEach((ele,i) => {
        //                     if(ele[1] == '') return
        //                     let name = ele[1];
        //                     if(i>0 && ele[1] == data[i-1][1] ){
        //                         name = ele[1]+"("+ele[0] + ")"
        //                         //return
        //                     }
        //                     let tmp = {};
        //                     let tmp1 = {};
        //                     tmp.name = name;
        //                     tmp.id = ele[2];
        //                     nodeJson.nodes.push(tmp)
        //                     tmp1.source = item;
        //                     tmp1.target = name;
        //                     tmp1.relation = ele[0];
        //                     nodeJson.links.push(tmp1)
        //                 });
        //             }
        //             that.updateDsCharts = nodeJson;
        //         })
        //     }) 
        // },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/news/newsTaskDetails.vue